import { QueryHookOptions } from '@apollo/client';
import { useUserRoles } from '@anytag/auth';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, QueryallStaffsArgs, useAllStaffsQuery } from '@anytag/graphql';

export const useAllStaffOptions = (options?: QueryHookOptions<Query, QueryallStaffsArgs>) => {
  const { isAdmin, isStaff } = useUserRoles();

  const { data, loading } = useAllStaffsQuery({
    skip: !(isAdmin || isStaff),
    fetchPolicy: 'cache-first',
    ...options
  });

  return { loading, allStaffOptions: getSelectOptions(data?.allStaffs) };
};
